import { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import Loader from "../../../components/loader";
import UiButton from "../../../components/button";
import TextInput from "../../../components/textinput/TextInput";
import Web3 from "web3";
import {
  useSecurityTokenDetails,
  useNetworkOptions,
} from "../../../context/contractDataLoaderService";

import {
  SecuritiesFactory,
  contractAddress,
} from "@verified-network/verified-sdk";
import { signMessage } from "../../../utils/response";
import {
  SuccessToast,
  FailureToast,
  ToastOptions,
  networks,
  NULL_ADDRESS,
  MarginIssueCategoryMarkers,
} from "../../../utils/constants";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Route, useHistory } from "react-router-dom";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../../utils/helpers/networks";
import { providers } from "ethers";
import { useGlobal } from "../../../context/globalContext";
import { getAllVerifiedCashBalances } from "../../../utils/helpers";

function Balance(props) {
  const history = useHistory();
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    verifiedWalletDetails,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [buttonText, setButtonText] = useState("Add Balance");
  const [changeContent, setChangeContent] = useState(false);
  const [exitingSecurity, setExistingSecurity] = useState("");
  const { data: networkOptions } = useNetworkOptions();
  let factoryContract;
  if (provider && provider.getSigner && chainId && address) {
    factoryContract = new SecuritiesFactory(
      signer,
      contractAddress[chainId].SecuritiesFactory,
    );
  }
  const addBalance = async () => {
    if (!web3.utils.isAddress(props.investorAddress)) {
      alert("Enter valid investor address");
      return;
    } else if (props.amount.length == 0) {
      alert("Enter amount");
      return;
    } else if (props.existingIssue && !web3.utils.isAddress(exitingSecurity)) {
      alert("Enter valid security address");
      return;
    }

    const securityTokenAddress = props.existingIssue
      ? exitingSecurity
      : props.security;
    setLoading(true);

    try {
      let paymentToken;

      if (
        verifiedWalletDetails &&
        Object?.keys(verifiedWalletDetails)?.length > 0
      ) {
        const cashTokens = await getAllVerifiedCashBalances(
          chainId,
          web3,
          account,
        );

        if (!cashTokens || cashTokens?.length === 0) {
          setLoading(false);
          toast.error(
            "No valid Cash Token on this network. Change network and try again.",
            ToastOptions,
          );

          return;
        }
        paymentToken = cashTokens[0];
        const txQuote = await factoryContract._getMeeQuote(
          cashTokens[0]?.address,
          "addBalance",
          [
            securityTokenAddress,
            MarginIssueCategoryMarkers.includes(props.productCategory)
              ? NULL_ADDRESS
              : props.existingIssue
                ? NULL_ADDRESS
                : account, //transferror
            props.investorAddress, //transferee
            web3.utils.toWei(props.amount, "ether"),
          ],
        );

        if (
          Number(cashTokens[0]?.balance) === 0 ||
          Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
        ) {
          setLoading(false);
          toast.error(
            `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
            ToastOptions,
          );

          return;
        }
      }

      await factoryContract
        .addBalance(
          securityTokenAddress,
          MarginIssueCategoryMarkers.includes(props.productCategory)
            ? NULL_ADDRESS
            : props.existingIssue
              ? NULL_ADDRESS
              : account, //transferror
          props.investorAddress, //transferee
          web3.utils.toWei(props.amount, "ether"),
          paymentToken?.address
            ? {
                paymentToken: paymentToken?.address,
                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
              }
            : {},
        )
        .then((res) => {
          setLoading(false);
          if (res?.status === 0) {
            const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${res?.response?.hash}`;
            toast.success(SuccessToast(transactionLink), ToastOptions);
            props.updateInvestorAddress("");
            props.updateAmount("");
            if (props.existingIssue) {
              props.updateSecurity(securityTokenAddress); //update props for next stages
            }
            setButtonText("Add Balance for another investor");
            setChangeContent(true);
          } else {
            toast.error("Transaction Failed", ToastOptions);
          }
        });
    } catch (err) {
      let error = { err };
      console.log(error);
      const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${error.err?.transactionHash}`;
      setLoading(false);
      toast.error(FailureToast(transactionLink), ToastOptions);
    }
  };
  return (
    <>
      <ToastContainer />
      {loading ? <Loader /> : null}
      <div className="d-grid gap-2">
        <Row className="ml-1 align-items-center">
          {props.existingIssue && (
            <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
              <Col xs={{ span: 3, offset: 2 }} className="text-left">
                <b>Sender Address</b>
              </Col>
              <Col className="pl-0" xs={5}>
                <TextInput
                  placeholder="Security address"
                  required
                  value={account}
                  disabled={true}
                />
              </Col>
            </Row>
          )}
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Investor Address</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="Investor/Receiver wallet address"
                required
                value={props.investorAddress}
                onChange={(e) => props.updateInvestorAddress(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Amount</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="Amount to credit"
                fieldType="number"
                required
                value={props.amount}
                onChange={(e) => props.updateAmount(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="mx-0 my-2 pl-0 width-100 align-items-center">
            <Col className="pl-0">
              <UiButton
                onClick={() => {
                  if (web3 && signer && chainId && account) {
                    addBalance();
                  }
                }}
                buttonVariant="primary"
                buttonClass="SignUpButton flex-1 ml-0"
                buttonText={buttonText}
                type="submit"
              />
            </Col>
          </Row>
        </Row>
        {props.existingIssue && !changeContent && (
          <UiButton
            onClick={() => {
              props.updateExistingModalView(3);
            }}
            buttonVariant="primary"
            buttonClass="SignUpButton flex-1 ml-0"
            buttonText="Skip&nbsp;&rarr;"
            type="submit"
          />
        )}
      </div>

      {changeContent &&
        !MarginIssueCategoryMarkers.includes(props.productCategory) && (
          <UiButton
            onClick={() => {
              props.existingIssue
                ? props.updateExistingModalView(3)
                : props.updateModalView(3);
            }}
            buttonVariant="primary"
            buttonClass="SignUpButton flex-1 ml-0"
            buttonText="Next&nbsp;&rarr;"
            type="submit"
          />
        )}
      {changeContent &&
        MarginIssueCategoryMarkers.includes(props.productCategory) && (
          <UiButton
            onClick={() => {
              history.push("/marginproducts");
            }}
            buttonVariant="primary"
            buttonClass="SignUpButton flex-1 ml-0"
            buttonText="View Margin Products"
            type="submit"
          />
        )}
    </>
  );
}

export default function AddSecondaryBalance(props) {
  return <Balance {...props} />;
}
